/**
 * @license hugeicons-react v0.1.3
 *
 * See the LICENSE file in the root directory of this source tree.
 */

import{forwardRef as p,createElement as s}from"react";import u from"./defaultAttributes.js";const y=(a,c)=>{const t=p(({color:i="currentColor",size:e=24,strokeWidth:l=1.5,className:m="",children:r,...n},d)=>{const f={ref:d,...u,width:e,height:e,strokeWidth:l,color:i,className:m,...n};return s("svg",f,c?.map(([h,o])=>s(h,{key:o.id,...o}))??[],...Array.isArray(r)?r:[r])});return t.displayName=`${a}Icon`,t};export{y as default};
